export class PrefixModel {
    public solutaionPrefixCode: string;
    public solutaionPrefixSapCode: string;
 }


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/models/prefixModel/prefixModel.ts